import React from 'react';
import './Contatos.scss';
import { Link } from 'react-router-dom';
import { Button, Container } from '@mui/material';
import logo from '../../../assets/images/logo.png';
import { BsInstagram, BsFacebook, BsPhone, BsTelephone, BsWhatsapp, BsCart3, BsHouse, BsGeoAlt, BsMailbox } from 'react-icons/bs';
import { MdOutlineMailOutline } from 'react-icons/md';

function Contatos() {

    return (
        <div className='quickContacts d-flex justify-content-center align-items-center'>
            <Container maxWidth='sm' className='py-4'>
                <div className='contactsLogo mb-4'>
                    <img src={logo} alt='Logo' />
                </div>

                <Link to='https://www.instagram.com/veiculosecia'>
                    <Button className='mb-4' variant='contained' fullWidth startIcon={<BsInstagram />} size='large'>INSTAGRAM</Button>
                </Link>

                <Link to='https://pt-br.facebook.com/veiculosecia'>
                    <Button className='mb-4' variant='contained' fullWidth startIcon={<BsFacebook />} size='large'>FACEBOOK</Button>
                </Link>

                <Link to='tel://6634617500'>
                    <Button className='mb-4' variant='contained' fullWidth startIcon={<BsTelephone />} size='large'>LIGUE AGORA - FIXO</Button>
                </Link>

                <Link to='tel://66999815612'>
                    <Button className='mb-4' variant='contained' fullWidth startIcon={<BsPhone />} size='large'>LIGUE AGORA - CELULAR</Button>
                </Link>

                <Link to='http://api.whatsapp.com/send?phone=5566999815612'>
                    <Button className='mb-4' variant='contained' fullWidth startIcon={<BsWhatsapp />} size='large'>WHATSAPP</Button>
                </Link>

                <Link to='https://wa.me/c/556699815612'>
                    <Button className='mb-4' variant='contained' fullWidth startIcon={<BsCart3 />} size='large'>CATÁLOGO</Button>
                </Link>

                <Link to='https://www.veiculoseciamt.com.br'>
                    <Button className='mb-4' variant='contained' fullWidth startIcon={<BsHouse />} size='large'>SITE</Button>
                </Link>

                <Link to='https://goo.gl/maps/ipBD8Up6BQzMTNDF9'>
                    <Button className='mb-4' variant='contained' fullWidth startIcon={<BsGeoAlt />} size='large'>LOCALIZAÇÃO</Button>
                </Link>

                <Link to='mailto:veiculoseciamt@hotmail.com'>
                    <Button variant='contained' fullWidth startIcon={<MdOutlineMailOutline />} size='large'>E-MAIL</Button>
                </Link>

            </Container>
        </div>
    )
}

export default Contatos;
